import styled from 'styled-components'

export const Space = styled.div`
  height: 15px;
`

export const FlexContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

export const FlexContainerBetween = styled(FlexContainer)`
  justify-content: space-between;
`

export const ButtonContainer = styled.div`
  margin: 0 7px;
`

export const HighlightText = styled.span`
  font-family: 'Poppins',sans-serif;
  font-size: 17px;
  color: var(--text);
`

export const CodeContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-evenly;

  margin-bottom: 50px;
`

export const ResendCodeButton = styled.a`
  cursor: pointer;
`

export const PopoverContainer = styled.div`
  position: absolute;
  z-index: 2;
  bottom: -10px;
  left: 20px;
  width: 192px;
`
